import { useEffect, useState } from 'react';
import Transform from '../../components/TransForm/Transform';
import StyledTable from '../../components/table-component/StyledTable';
import { useDispatch, useSelector } from 'react-redux';
import { createTypeFrais, deleteTypeFrais, fetchTypeFrais, updateTypeFrais } from '../../data/slices/typeFraisSlice';
import BaseParameter from '../../data/schemas/baseParameter';
import { notify } from '../../settings/toastSetting';
import { 
    Button, 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    Box, 
    Typography, 
    alpha,
    TextField,
    InputAdornment,
    Paper,
    Card,
    CardContent
} from '@mui/material';
import { Add, Search } from '@mui/icons-material';
import { output, sortByProp, COLORS } from '../../settings/themeSettings';
import useIsAdmin from '../../hooks/useIsAdmin';




const TypeFraisPage = (props) => {
    const { typeFrais } = useSelector((state) => state.typeFrais);
    const dispatch = useDispatch();
    const isAdmin = useIsAdmin();
    const [typeFrai, setTypeFrai] = useState(null);
    const [open, setOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const handleClose = ()=>{
        setOpen(false);
    }

    const addTypeFrais = (data, cb)=> {
        output(data);
        handleClose();
        if(data.id){

            updateTypeFrais(data, (err) => {
                output(err);
            }, (resp) => {
                cb();
                output(resp);
            notify("le type a été enregistré avec succès !");
            dispatch(fetchTypeFrais());
    
    
            });
    

            return;
        }

        createTypeFrais(data, (err) => {
            output(err);
        }, (resp) => {
            output(resp);
            cb();

            notify("Le type de frais a  été ajouté avec succés!");
            dispatch(fetchTypeFrais());
        });
    }

    const onTypeFraiSelected = (id) => { 
        setTypeFrai(typeFrais.find((t) => t.id === id));
        setOpen(true);
    };


    const onDelete = (id) => {
        handleClose();
        deleteTypeFrais(id, (err) => {
            output(err);
        }, (resp) => {
            output(resp);
            setTypeFrai(null);

        notify("Le type a bien été supprimé!");
        dispatch(fetchTypeFrais());

        });
    }

    useEffect(() => {
        dispatch(fetchTypeFrais());
    }, [dispatch]);

    // Filtrer les types de frais en fonction du terme de recherche
    const filteredTypeFrais = typeFrais.filter(frais => 
        frais.libelle.toLowerCase().includes(searchTerm.toLowerCase())
    ).sort((a, b) => sortByProp(a, b, 'libelle'));

    const handleAddNew = () => {
        setTypeFrai(null);
        setOpen(true);
    };

    const handleEdit = (id) => {
        onTypeFraiSelected(id);
    };

    return (
        <Box sx={{ p: 3, backgroundColor: alpha(COLORS.gray?.[50] || '#f5f5f5', 0.5), minHeight: '100vh' }}>
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h4" fontWeight="bold" color={COLORS.secondary}>
                        Gestion des Types de Frais
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<Add />}
                        onClick={handleAddNew}
                        sx={{
                            backgroundColor: COLORS.primary,
                            '&:hover': { backgroundColor: alpha(COLORS.primary, 0.9) },
                            px: 3
                        }}
                    >
                        Ajouter un type de frais
                    </Button>
                </Box>

                <TextField
                    fullWidth
                    placeholder="Rechercher un type de frais..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search sx={{ color: 'text.secondary' }} />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ mb: 3 }}
                    size="small"
                />

                <Card elevation={1}>
                    <CardContent sx={{ p: 0 }}>
                        {filteredTypeFrais.length === 0 ? (
                            <Box sx={{ textAlign: 'center', py: 8, color: 'text.secondary' }}>
                                <Typography variant="h6" sx={{ mb: 1 }}>
                                    {searchTerm ? 'Aucun résultat trouvé' : 'Aucun type de frais'}
                                </Typography>
                                <Typography variant="body2">
                                    {searchTerm 
                                        ? 'Essayez de modifier votre recherche' 
                                        : 'Commencez par ajouter un type de frais'}
                                </Typography>
                            </Box>
                        ) : (
                            <StyledTable  
                                rows={filteredTypeFrais} 
                                head={['libelle']}
                                onOptionClicked={handleEdit}
                            />
                        )}
                    </CardContent>
                </Card>

                {typeFrais.length > 0 && (
                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                            {filteredTypeFrais.length} type{filteredTypeFrais.length > 1 ? 's' : ''} de frais{searchTerm && ' (filtré)'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Total: {typeFrais.length} type{typeFrais.length > 1 ? 's' : ''} de frais
                        </Typography>
                    </Box>
                )}
            </Paper>

            <Dialog 
                open={open} 
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: { borderRadius: 2 }
                }}
            >
                <DialogTitle sx={{ backgroundColor: COLORS.primary, color: 'white' }}>
                    {typeFrai ? 'Détails du type de frais' : 'Ajouter un type de frais'}
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    <Transform 
                        onSubmit={addTypeFrais} 
                        mandatories={["libelle"]} 
                        entity={new BaseParameter()}
                        toUpdate={typeFrai} 
                        onDelete={onDelete}
                        onCancel={handleClose}
                    />
                </DialogContent>
            </Dialog>
        </Box>
    );

}


export default TypeFraisPage;
